<div class="history-entry">
  <div class="entry-header">
    <div class="date">{{ date }}</div>
    <div class="entry-actions" *ngIf="downloadable">
      <button class="link print" (click)="onPrintInvoice()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 5V2h8v3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <rect x="2" y="5" width="12" height="7" rx="1" stroke="currentColor" stroke-width="1.5"/>
          <path d="M4 9h8M4 12h8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
        <span>Print Receipt</span>
      </button>
      <button class="link download" (click)="onDownloadInvoice()">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8 3v7m0 0l3-3m-3 3L5 7" stroke="#003FE0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <span>Download Invoice</span>
      </button>
    </div>
  </div>
  <div class="line-item" 
       *ngFor="let i of items; trackBy: trackByIndex"
       [class.discount-row]="i.amount.startsWith('-')">
    <span>{{ i.label }}</span>
    <span [class.discount-amount]="i.amount.startsWith('-')">{{ i.amount }}</span>
  </div>
  <div class="divider"></div>
  <div class="line-item total"><span>{{ totalLabel }}</span><span>{{ totalAmount }}</span></div>
  <div class="line-item payment-method" *ngIf="paymentMethod && paymentMethod !== '-'">
    <span>Payment Mode</span>
    <span>{{ paymentMethod }}</span>
  </div>
</div>


